module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/girl-smiling-pink-jacket/girl-smiling-pink-jacket@1x.png"